import React from 'react';

export default function AddEmployer() {
  return (
    <div>
      <p>Steps to Add an Employer</p>
      <p><strong>Step 1: Access Employer Management</strong></p>
      <ol>
        <li>Navigate to the Employers section in the dashboard.</li>
        <li>Click on the Add Employer button to open the employer registration form.</li>
      </ol>
      <p><strong>Step 2: Enter Employer Details</strong></p>
      <p>Fill in the following fields in the form:</p>
      <ul>
        <li>
          <strong>First Name:</strong>
          <ul>
            <li>Enter the employer’s first name.</li>
            <li>Example: Alex</li>
          </ul>
        </li>
        <li>
          <strong>Last Name:</strong>
          <ul>
            <li>Enter the employer’s last name.</li>
            <li>Example: Smith</li>
          </ul>
        </li>
        <li>
          <strong>E-Mail:</strong>
          <ul>
            <li>Provide a valid email address.</li>
            <li>Example: alexsmith@example.com</li>
          </ul>
        </li>
        <li>
          <strong>Password:</strong>
          <ul>
            <li>Set a strong password for the employer account.</li>
            <li>Example: SecureP@ss123</li>
          </ul>
        </li>
      </ul>

      <img
        src=" https://res.cloudinary.com/danfpnuui/image/upload/v1737787320/Employer_create-1_nwhipw.png   "
        alt="Import Resume"
        className="placeholder-image image_gatnix_support"
      />

      <p><strong>Step 3: Add Contact Information</strong></p>
      <ul>
        <li>
          <strong>Mobile Number:</strong>
          <ul>
            <li>Enter the employer’s mobile number with the country code.</li>
            <li>Example: +1 555-678-9101</li>
          </ul>
        </li>
        <li>
          <strong>WhatsApp Number:</strong>
          <ul>
            <li>If the WhatsApp number is the same as the mobile number, check the Same As Mobile Number box.</li>
            <li>Otherwise, manually enter the WhatsApp number.</li>
          </ul>
        </li>
      </ul>
      <p><strong>Step 4: Save the Employer</strong></p>
      <ol>
        <li>Double-check all entered details for accuracy.</li>
        <li>Click Save to add the employer to the system.</li>
      </ol>
      <p><strong>Optional: Cancel</strong></p>
      <ul>
        <li>If you wish to exit without saving, click Cancel.</li>
      </ul>
      <p><strong>Confirmation</strong></p>
      <p>
        After saving, a message will appear: <em>“Employer successfully added.”</em>
      </p>
    </div>
  );
}
